import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SalesTargetEditPage } from './sales-target-edit.page';

const routes: Routes = [
  {
    path: '',
    component: SalesTargetEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesTargetEditPageRoutingModule {}
